import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDynCollectionsVideos } from '../../../../service/admin/adminDynTube.service';
import { Helmet } from 'react-helmet-async';
import Loaders from '../../../../components/loaders/Loaders';
import BreadcrumbBack from '../../../../components/breadcrumb/BreadcrumbBack';
import { FaPlay, FaClock, FaCalendarAlt, FaCheck, FaCheckSquare, FaSquare, FaDownload } from 'react-icons/fa';
import { truncateString } from '../../../../helpers/helpers';
import Models from '../../../../components/models/Models';
import YoutubePlayer2 from '../../../../components/player/VimeoPlayer2';
import moment from 'moment';
import { SubmitHandler, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import MultiSearchableSelect from '../../../../components/form/MultiSearchableSelect';
import { getVideosActiveModule, getVideosActiveSubModuleByModule } from '../../../../service/admin/adminVideoes.service';
import FormButton from '../../../../components/button/FormButton';
import { importGumletPlaylistVideos } from '../../../../service/admin/adminGumlet.service';
import { generateRandomString } from '../../../../helpers/commonHelper';

export default function DynVideos() {
  const navigate = useNavigate();
  const [pageLoad, setPageLoad] = useState(false);
  const [fetchData, setFetchData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [moduleData, setModuleData] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState<any>(false);
  const [selectedVideos, setSelectedVideos] = useState<Set<string>>(new Set());
  const [show, setShow] = useState<any>('module');
  const [currectUrl, setCurrentUrl] = useState<any>();
  const [moduleSubData, setModuleSubData] = useState<any>([]);
  const location = useLocation();
  const { handleSubmit, control } = useForm<any>();
  const projectId = location.pathname.split('/')[4];
  const query: any = new URLSearchParams(location.search);

  const fetch = async () => {
    setPageLoad(true);
    const get: any = await getDynCollectionsVideos(projectId);
    if (get?.status === 'success') {
      setFetchData(get?.message?.data);
    }
    setPageLoad(false);
  };

  useEffect(() => {
    fetch();
  }, []);

  const handlePlay = (item: any) => {
    setOpen(!open);
    setCurrentUrl(item);
  };

  const handleSelectVideo = (videoId: string) => {
    const newSelected = new Set(selectedVideos);
    if (newSelected.has(videoId)) {
      newSelected.delete(videoId);
    } else {
      newSelected.add(videoId);
    }
    setSelectedVideos(newSelected);
  };

  const handleSelectAll = () => {
    if (selectedVideos.size === fetchData.length) {
      setSelectedVideos(new Set());
    } else {
      setSelectedVideos(new Set(fetchData.map((item: any) => item.id)));
    }
  };

  const handleAllCheckBoxedItems = async () => {
    if (selectedVideos.size === 0) {
      return toast.error('Please select at least one video');
    }
    fetchModules();
    setOpen1(!open1);
  };

  const onSubmit: SubmitHandler<any> = async (data: any) => {
    setLoading(true);
    let datam: any = [];
    if (data?.fk_submodule_id?.length > 0) {
      data.fk_submodule_id.map((item: any) => {
        let find: any = moduleSubData.find((i: any) => i.value === item);
        datam.push({
          m: find.module,
          s: find.value,
        });
      });
    }

    if (datam.length !== 0) {
      const selectedItems = fetchData.filter((item: any) => selectedVideos.has(item.id));
      
      if (selectedItems.length !== 0) {
        let newData: any = [];
        selectedItems.map((item: any) => {
          const [hh, mm, ss] = item.duration.split(':');
          const totalSeconds =
            parseInt(hh) * 3600 +
            parseInt(mm) * 60 +
            parseFloat(ss);
          newData.push({
            name: item.title,
            length: totalSeconds,
            slug: generateRandomString(10) + '_' + item.id,
            description: 'dyn tube',
            thumbnail: item.image.smUrl,
            url: item.hlsUrl,
            status: true,
            watchtime: 0,
          });
        });

        if (newData.length === 0) {
          setLoading(false);
          return toast.error('Please select video');
        } else {
          let cr: any = await importGumletPlaylistVideos(newData, datam);
          if (cr?.status === 'success') {
            setLoading(false);
            navigate('/admin/videos');
            toast.success('Videos imported successfully');
          }
        }
      }
    }
    setLoading(false);
  };

  const fetchSubModules = async (id: string) => {
    const get: any = await getVideosActiveSubModuleByModule(id);
    if (get?.status === 'success') {
      let data: any = [];
      get.message.map((item: any) => {
        data.push({
          value: item.id,
          label: item.name,
          module: item.fk_videoModule_id,
        });
      });
      let newarray = [...moduleSubData, ...data];
      setModuleSubData(newarray);
    }
  };

  const handlefetch = async (data: any) => {
    if (data?.selected.length > 0) {
      if (data?.removed === undefined) {
        fetchSubModules(data?.selected[data?.selected.length - 1]);
      } else {
        let updated = moduleSubData.filter(
          (item: any) => item.module !== data?.removed
        );
        setModuleSubData(updated);
      }
    } else {
      setModuleSubData([]);
    }
  };

  const fetchModules = async () => {
    const get: any = await getVideosActiveModule();
    if (get?.status === 'success') {
      let data: any = [];
      get.message.map((item: any) => {
        data.push({ value: item.id, label: item.name });
      });
      setModuleData(data);
    }
  };

  const formatDuration = (duration: string) => {
    if (!duration) return '--:--';
    return duration;
  };

  return (
    <>
      <Helmet>
        <title>{`DynTube Videos | ${window.location.hostname}`}</title>
      </Helmet>
      {pageLoad ? (
        <Loaders type="spinner" />
      ) : (
        <div className="min-h-screen">
          <BreadcrumbBack title={`${query.get('name')}'s Videos`}>
            {selectedVideos.size > 0 && (
              <button
                disabled={loading}
                onClick={handleAllCheckBoxedItems}
                className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 rounded-xl text-white font-semibold shadow-lg hover:shadow-xl transition-all duration-200"
              >
                <FaDownload />
                {loading ? 'Importing...' : `Import ${selectedVideos.size} Video${selectedVideos.size > 1 ? 's' : ''}`}
              </button>
            )}
          </BreadcrumbBack>

          {/* Stats Bar */}
          <div className="my-4 bg-gradient-to-r from-purple-50 to-indigo-50 p-4 rounded-xl shadow-sm border border-purple-100">
            <div className="flex items-center justify-between flex-wrap gap-4">
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <FaPlay className="text-purple-600" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Total Videos</p>
                    <p className="text-lg font-bold text-gray-800">{fetchData.length}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center">
                    <FaCheck className="text-indigo-600" />
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Selected</p>
                    <p className="text-lg font-bold text-gray-800">{selectedVideos.size}</p>
                  </div>
                </div>
              </div>

              {/* Select All Toggle */}
              <button
                onClick={handleSelectAll}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                  selectedVideos.size === fetchData.length && fetchData.length > 0
                    ? 'bg-purple-600 text-white shadow-md'
                    : 'bg-white text-gray-600 hover:bg-purple-100 border border-gray-200'
                }`}
              >
                {selectedVideos.size === fetchData.length && fetchData.length > 0 ? (
                  <FaCheckSquare />
                ) : (
                  <FaSquare />
                )}
                {selectedVideos.size === fetchData.length && fetchData.length > 0 ? 'Deselect All' : 'Select All'}
              </button>
            </div>
          </div>

          {/* Videos Grid */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6">
            {fetchData.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {fetchData.map((item: any, index: number) => (
                  <div
                    key={index}
                    className={`group relative bg-white rounded-xl border-2 overflow-hidden transition-all duration-300 hover:shadow-xl ${
                      selectedVideos.has(item.id)
                        ? 'border-purple-500 shadow-lg shadow-purple-100'
                        : 'border-gray-100 hover:border-purple-200'
                    }`}
                  >
                    {/* Thumbnail */}
                    <div className="relative aspect-video bg-gray-900 overflow-hidden">
                      <img
                        src={item.image?.smUrl || item.image?.url}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                      
                      {/* Overlay on hover */}
                      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                        <button
                          onClick={() => handlePlay(item.hlsUrl)}
                          className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center shadow-xl transform scale-90 group-hover:scale-100 transition-transform duration-300"
                        >
                          <FaPlay className="text-purple-600 text-xl ml-1" />
                        </button>
                      </div>

                      {/* Duration Badge */}
                      <div className="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-2 py-1 rounded-md flex items-center gap-1">
                        <FaClock className="text-[10px]" />
                        {formatDuration(item.duration)}
                      </div>

                      {/* Selection Checkbox */}
                      <button
                        onClick={() => handleSelectVideo(item.id)}
                        className={`absolute top-2 left-2 w-6 h-6 rounded-md flex items-center justify-center transition-all duration-200 ${
                          selectedVideos.has(item.id)
                            ? 'bg-purple-600'
                            : 'bg-white/80 hover:bg-white'
                        }`}
                      >
                        {selectedVideos.has(item.id) ? (
                          <FaCheck className="text-white text-xs" />
                        ) : (
                          <div className="w-3 h-3 border-2 border-gray-400 rounded-sm" />
                        )}
                      </button>

                      {/* Index Badge */}
                      <div className="absolute top-2 right-2 bg-purple-600 text-white text-xs px-2 py-1 rounded-md font-semibold">
                        #{index + 1}
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-4">
                      <h3
                        data-tooltip={item.title}
                        className="font-semibold text-gray-800 mb-2 line-clamp-2 group-hover:text-purple-700 transition-colors"
                      >
                        {truncateString(item?.title, 40)}
                      </h3>

                      <div className="flex items-center gap-2 text-xs text-gray-500">
                        <FaCalendarAlt />
                        <span>{moment(item.created).format('MMM DD, YYYY')}</span>
                        <span className="text-gray-300">•</span>
                        <span>{moment(item.created).fromNow()}</span>
                      </div>
                    </div>

                    {/* Quick Action Bar */}
                    <div className="px-4 pb-4 flex gap-2">
                      <button
                        onClick={() => handlePlay(item.hlsUrl)}
                        className="flex-1 flex items-center justify-center gap-2 py-2 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white text-sm font-medium rounded-lg transition-all duration-200"
                      >
                        <FaPlay className="text-xs" />
                        Preview
                      </button>
                      <button
                        onClick={() => handleSelectVideo(item.id)}
                        className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                          selectedVideos.has(item.id)
                            ? 'bg-green-100 text-green-700 hover:bg-green-200'
                            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                        }`}
                      >
                        {selectedVideos.has(item.id) ? <FaCheck /> : 'Select'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center py-16 text-gray-400">
                <FaPlay className="text-8xl mb-4 opacity-30" />
                <h3 className="text-xl font-semibold text-gray-500">No Videos Found</h3>
                <p className="text-sm text-gray-400 mt-2">This collection has no videos yet</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Video Player Modal */}
      <Models name="Video Preview" isOpen={open} isClose={setOpen}>
        <YoutubePlayer2 url={currectUrl} watchTime={0} role="common" type={'vimoe'} />
      </Models>

      {/* Import Modal */}
      <Models name="Import Videos" isOpen={open1} isClose={setOpen1}>
        <>
          <div className="mb-4 p-3 bg-purple-50 rounded-lg border border-purple-100">
            <p className="text-sm text-purple-700">
              <strong>{selectedVideos.size}</strong> video{selectedVideos.size > 1 ? 's' : ''} selected for import
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            {show === 'module' ? (
              <>
                <MultiSearchableSelect
                  name="fk_module_id"
                  control={control}
                  options={moduleData}
                  onFetch={handlefetch}
                  label="Select Module"
                />
                <MultiSearchableSelect
                  name="fk_submodule_id"
                  control={control}
                  options={moduleSubData}
                  label="Select Sub Module"
                />
              </>
            ) : null}
            <div className="pt-4">
              <FormButton loading={loading} title={'Import Videos'} />
            </div>
          </form>
        </>
      </Models>
    </>
  );
}
